import React from 'react';

interface SettingsLayoutProps {
  children: React.ReactNode;
  currentPath: string;
  onNavigate: (path: string) => void;
}

export const SettingsLayout: React.FC<SettingsLayoutProps> = ({
  children,
}) => {
  return (
    <main className="flex-1 min-w-0 flex flex-col overflow-hidden">{children}</main>
  );
};
